import { definePage } from '@reflex/plugin-api/web';
import type { PluginWebManifest } from '@reflex/plugin-api/web';
import { AWS_CREDENTIAL_ATTACHMENT_ID } from './shared/types.js';

const page = definePage({
  path: '/configure/connect/aws',
  label: 'AWS',
  icon: 'Aws',
  group: 'security',
  componentPath: '@reflex/plugin-aws/web/AwsPage',
  description: 'Put AWS credentials on agent devboxes.',
  details:
    'Register access keys and assumable IAM roles per organization, team, or user, then attach them to agent runs. Each attached credential becomes a named profile in ~/.aws/config on the devbox, so the AWS CLI and every SDK pick it up without any extra setup.',
  features: [
    'Static access keys stored encrypted per organization',
    'Assume-role credentials chained to a source access key',
    'Attach one or more credentials to an agent run from the launch picker',
    'Named profiles in ~/.aws/config with the first selection as default',
    'AWS section on every agent detail page',
  ],
});

export const awsWeb: PluginWebManifest = {
  ...page.web,
  orgSetupComponent: {
    componentPath: '@reflex/plugin-aws/web/AwsPage',
    label: 'Add an AWS access key or role so devboxes can reach your AWS account.',
  },
  attachments: [
    {
      id: AWS_CREDENTIAL_ATTACHMENT_ID,
      label: 'AWS Credentials',
      icon: 'Aws',
      order: 32,
      pickerComponentPath: '@reflex/plugin-aws/web/AwsCredentialPicker',
      summaryComponentPath: '@reflex/plugin-aws/web/AwsCredentialSummary',
    },
  ],
  agentDetailSections: [
    {
      id: AWS_CREDENTIAL_ATTACHMENT_ID,
      label: 'AWS',
      icon: 'Aws',
      componentPath: '@reflex/plugin-aws/web/AwsDetailSection',
      order: 16,
    },
  ],
};
